import React from 'react';

const LoadingState = ({ message = "Chargement des bulletins..." }) => {
  return (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#202654]"></div>
      <span className="ml-3 text-gray-600">{message}</span>
    </div>
  );
};

export default LoadingState;